import React from 'react';
import {Select} from 'components/forms';
import {Row, Col, Loader} from 'components';
import {Button} from 'components/layout';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import IntlWrapper from 'components/layout/intlWrapper';
import ReactDOM from 'react-dom';
import events from 'lib/events';
import Header from 'components/layout/header';
import session from 'services/sessionService';
import csvApi from 'api/csv';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import PageFooter from 'components/layout/pageFooter';
import DeviceTools from 'page/tools/devices';
import AccountTools from 'page/tools/accounts';
import DatabaseTools from 'page/tools/database';

let render = (container) => {
  console.info('[UI.page.tools.calibration] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperDatabaseUpload /></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools.calibration] register route');
router.rr.add([{path: 'tools/upload', handler: routeUtils.requireAuth(render)}]);

class DatabaseUpload extends React.Component {
  state = {
    errors: [],
    success: false,
    format: 'cust-only',
    sending: false,
    uploadEnabled: false,
  };

  enableUpload = () => {
    setTimeout(() => { // Delay 5 seconds since doesn't seem to register right away
      this.setState({
        uploadEnabled: true,
      });
    }, 500);
  };

  updateFormat = ({value}) => {
    this.setState({format: value});
  };

  uploadFile = () => {
    let {formatMessage} = this.props.intl;
    let file = this.refs.csvFile.files[0];

    if (file) {
      this.setState({success: false, errors: [], sending: true, uploadEnabled: false});
      csvApi.upload(file, this.state.format.replace('clearcare', 'waterlink'))
        .then(() => {
          if (this.state.format !== 'cust-only') {
            events.publish('success.user', {message: formatMessage({id: 'tools.database.processing.file'})});
          } else {
            events.publish('success.user', {message: 'Upload Successful. The customers you uploaded will appear within the next 30 minutes.'});
          }
          this.setState({success: true, errors: [], sending: false});
        })
        .catch((response) => {
          if (response instanceof Array) {
            this.setState({errors: response.data, sending: false});
            events.publish('warn.user', {
              message:
  <span>
    <FormattedMessage id="tools.database.there.are" /> {response.data.length} <FormattedMessage id="tools.database.errors.uploaded" />
  </span>
              ,
            });
          } else {
            if (response.data) {
              const {errors, csv: filepath} = response.data;

              this.setState({errors, sending: false});
              events.publish('warn.user', {
                message:
  <span>
    <FormattedMessage id="tools.database.there.are" /> {errors.length} <FormattedMessage id="tools.database.error.download" />
    <a className='btn btn-primary pull-right' href={'UploadCSV/DownloadErrors/?file=' + filepath}><FormattedMessage id="general.download" /></a>
  </span>
                ,
              });
            } else if (response.message) {
              this.setState({sending: false});
              events.publish('warn.user', {
                message:
  <span>
    {response.message}
  </span>
                ,
              });
            }
          }
        });
    }
  };

  render() {
    let {formatMessage} = this.props.intl;
    let subPages = {
      devices: {name: formatMessage({id: 'general.devices'}), element: <DeviceTools />, permissionLevel: 1000},
      accounts: {name: formatMessage({id: 'general.accounts'}), element: <AccountTools />, permissionLevel: 2000},
      database: {name: formatMessage({id: 'general.database'}), element: <DatabaseTools />, permissionLevel: 3000},
      // globalSystemUpdate: {name: 'Global System Update', element: <GlobalSystemUpdate />, permissionLevel: 3000},
    };

    let subPagesTabs = Object.keys(subPages)
      .filter(sp => subPages[sp].permissionLevel <= session.getUser().privileges.level)
      .map(sp => <a key={sp} className={sp === 'database' ? 'active' : ''}
        href={'#tools/' + sp}>{subPages[sp].name}
      </a>);

    return (
      <div className='upload-page container'>
        <Header mainTitle={formatMessage({id: 'tools.title'})} subTitle={formatMessage({id: 'tools.database.customer.upload'})} mainTitleReturn='tools' />
        <nav className='navigation-tabs'>
          {subPagesTabs}
        </nav>
        <div className='row'>
          <div className='col-sm-12'>
            <h2><FormattedMessage id="tools.database.customer.upload" /></h2>
            <p className='b'><FormattedMessage id="tools.database.upload.populated" /></p>
            <div className='form-group'>
              <Row>
                <Col md={4}>
                  <Select label='Format' options={[formatMessage({id: 'tools.database.customers.only'}), formatMessage({id: 'tools.database.waterlink.connect'}), formatMessage({id: 'tools.database.clear.care'})]} keys={['cust-only', 'waterlink', 'clearcare']}
                    dataChanged={this.updateFormat} value={this.state.format} />
                </Col>
                <Col md={4}>
                  <input type='file' ref='csvFile' className='pull-left' style={{margin: '3px 10px 0px 0px'}}
                    onChange={this.enableUpload} />
                  <br />
                  <i><FormattedMessage id="tools.database.required.format" />: csv</i>
                </Col>
                <Col md={4}>
                  <Button primary onClick={this.uploadFile} style={{marginTop: 20}} disabled={!this.state.uploadEnabled}>{formatMessage({id: 'general.upload'})}</Button>
                </Col>
              </Row>

            </div>
            <Loader loaded={!this.state.sending}>
              {this.state.format === 'cust-only' ? <div className='well'>
                <p>
                  <span className='b'><FormattedMessage id="tools.database.data.validation" />: </span>
                  <FormattedMessage id="tools.database.system.validate" />
                </p>
                <p><i><FormattedMessage id="tools.database.see.example" /></i></p>
                <ul>
                  <li><FormattedMessage id="tools.database.contact.information" /></li>
                  <li><FormattedMessage id="tools.database.contact.following" /></li>
                  <li><FormattedMessage id="tools.database.email.address" /></li>
                  <li><FormattedMessage id="tools.database.phone.number" /></li>
                  <li><FormattedMessage id="tools.database.street.address" /></li>
                  <li><FormattedMessage id="tools.database.state.abbreviations" /></li>
                  <li><FormattedMessage id="tools.database.zip.codes" /></li>
                  <li><FormattedMessage id="tools.database.duplicate.customer" /></li>
                </ul>
              </div> : <div className='well'>
                <p>
                  <span className='b'><FormattedMessage id="tools.database.data.validation" />: </span>
                  <FormattedMessage id="tools.database.this.format" /> <em>{this.state.format === 'waterlink' ? formatMessage({id: 'tools.database.waterlink.connect'}) : formatMessage({id: 'tools.database.clear.care'})} <FormattedMessage id="tools.database.application" /></em>. <FormattedMessage id="tools.database.few.minutes" />
                </p>
              </div>}
            </Loader>
            {this.state.success ?
              <div>
                {this.state.format === 'cust-only' ? <p className='b'><FormattedMessage id="tools.database.successful.upload" />!</p> : null}
              </div> :
              null
            }
            {this.state.errors.length > 0 ?
              <div>
                <h2><FormattedMessage id="tools.database.file.errors" /></h2>
                <hr />
                {this.state.errors.map((message, idx) =>
                  <p key={idx}><i className='fa fa-chevron-right' /> {message}</p>
                )}
              </div> :
              null
            }
          </div>
        </div>
        {this.state.format === 'cust-only' ? <PageFooter>
          <a className='footer-link' href='/Content/CustomerUploadTemplate.csv'>
            <span className='footer-item'>
              <i className='bl bl-export footer-item-icon fa-2x' />
              <FormattedMessage id="tools.database.download.template" />
            </span>
          </a>
        </PageFooter>  : null}
      </div>
    );
  }
}

let WrapperDatabaseUpload = injectIntl(DatabaseUpload);

export default WrapperDatabaseUpload;
